import { render, staticRenderFns } from "./setNickName.vue?vue&type=template&id=4dfc55bf&scoped=true"
import script from "./setNickName.vue?vue&type=script&lang=js"
export * from "./setNickName.vue?vue&type=script&lang=js"
import style0 from "./setNickName.vue?vue&type=style&index=0&id=4dfc55bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc55bf",
  null
  
)

export default component.exports